import React from "react";
import "../AllNotes.css";

const CircleLoader = () => {
   return (
      <div className="d-flex justify-content-center align-items-center text-center">
         <div className="d-flex justify-content-center">
            <div style={{ width: "8rem", height: "8rem" }} className="spinner-border  loader-color text-center"></div>
         </div>
      </div>
   );
};

export default CircleLoader;
